import { ListGroup, OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './ScrollableList.module.scss';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

function ScrollableList(props) {
  const { listId, list, text } = props;
  const [shouldShowList, setShouldShowList] = useState(false);

  return (
    <OverlayTrigger
      trigger="focus"
      placement="bottom"
      overlay={
        shouldShowList ? (
          <Popover id={`popover-${listId}`}>
            <ListGroup
              className={styles.listGroup}
              onMouseLeave={() => setShouldShowList(false)}
              style={{ height: list.length <= 7 ? 'auto' : '200px' }}
            >
              {list.map((channel) => (
                <ListGroup.Item key={channel.key}>{channel.value}</ListGroup.Item>
              ))}
            </ListGroup>
          </Popover>
        ) : (
          <></>
        )
      }
    >
      <button className={styles.clickable} onClick={() => setShouldShowList(!!list.length)} disabled={!list.length}>
        {text}
      </button>
    </OverlayTrigger>
  );
}
export default ScrollableList;

ScrollableList.propTypes = {
  listId: PropTypes.number.isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  text: PropTypes.string.isRequired,
};
